import { IFile } from '@/api/nodes/mutations/directory/create-directory-mutation'
import { IChildrenProps } from '@/utils/typings/children-props'
import { createContext, useContext } from 'react'

interface IFileContext {
    file: IFile
}

const FileContext = createContext<IFileContext>(undefined as unknown as IFileContext)

interface IFileContextProviderProps extends IChildrenProps {
    file: IFile
}

export const FileContextProvider = ({ file, children }: IFileContextProviderProps) => {
    return <FileContext.Provider value={{ file }}>{children}</FileContext.Provider>
}

export const useFileContext = (): IFileContext | undefined => useContext(FileContext)
